import { CommodityFilterInput, CommodityStats } from '@bechtel/types';
import { useLazyQuery, QueryTuple } from '@apollo/client';
import { GET_COMMODITY_STATS_REJECTED_FWE } from '@bechtel/client-gql';

export function useCommodityStatsRejectedFWE(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_STATS_REJECTED_FWE,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
